import { Service } from '@toeverything/infra';
import { track } from '@affine/track';

import { Doc } from '../entities/doc';

export class DocService extends Service {
  public readonly doc = this.framework.createEntity(Doc);

  private readonly _undoRedoListeners = new Map<string, () => void>();

  constructor() {
    super();

    // 监听文档变化，设置 undo/redo 监听器
    // this.doc.blockSuiteDoc.slots.ready.subscribe(() => {
    this._setupUndoRedoListener();
    // });
  }

  /**
   * �� 为当前文档设置 undo/redo 监听器
   */
  private _setupUndoRedoListener(): void {
    const docId = this.doc.id;

    // 如果已经设置过监听器，先清理
    if (this._undoRedoListeners.has(docId)) {
      this._undoRedoListeners.get(docId)?.();
      this._undoRedoListeners.delete(docId);
    }

    const blockSuiteDoc = this.doc.blockSuiteDoc;
    const undoManager = blockSuiteDoc.history.undoManager;

    if (!undoManager) {
      console.warn('⚠️ UndoManager 未找到，跳过设置 undo/redo 监听器');
      return;
    }

    // 🔑 监听 stack-item-popped 事件，获取精确的变化信息
    const handleStackItemPopped = (event: any) => {
      const { stackItem, type, changedParentTypes, origin } = event;
      console.log(`🔍 文档 ${docId} StackItem popped: ${type}`, {
        stackItem,
        changedParentTypes: Array.from(changedParentTypes.keys()).map(
          (t: any) => t.constructor.name
        ),
      });

      const stackItemTypes = this._extractBlockTypesFromStackItem(stackItem);
      if (
        !stackItemTypes &&
        origin.undoStack.length === 0 &&
        stackItem.meta.size <= 1
      ) {
        window.dispatchEvent(new CustomEvent('navigateToHome'));
        // 删除当前文档
        try {
          const workspace = this.doc.workspace.docCollection;
          workspace.removeDoc(docId);
          window.dispatchEvent(
            new CustomEvent('docDeleted', { detail: docId })
          );
          // 发送自定义事件

          console.log(`✅ 已彻底删除文档 ${docId}`);
        } catch (error) {
          console.warn(`❌ 删除文档 ${docId} 失败:`, error);
        }
      }

      //   🔑 直接使用 track 进行跟踪
      this._trackUndoRedoOperation(docId, type, {
        // changedParentTypes: blockTypes,
        // stackItemTypes: stackItemTypes,
        docId,
        block_type: stackItemTypes,
      });
    };

    // 添加事件监听器
    undoManager.on('stack-item-popped', handleStackItemPopped);

    // 保存清理函数
    const cleanup = () => {
      undoManager.off('stack-item-popped', handleStackItemPopped);
    };

    this._undoRedoListeners.set(docId, cleanup);
    console.log(`✅ 已为文档 ${docId} 设置 undo/redo 监听器`);
  }

  /**
   * 🔑 从 StackItem 结构中提取块类型信息
   */
  private _extractBlockTypesFromStackItem(stackItem: any): string {
    const blocId = stackItem.meta.get('selection-state')?.[0]?.blockId;
    console.log(
      'StackItem poppedblocId',
      blocId,
      stackItem.meta,
      stackItem,
      stackItem.meta.get('selection-state'),
      stackItem.meta.get('selection-state')?.[0]
    );
    if (blocId) {
      const block = this.doc.blockSuiteDoc.getBlock(blocId);
      console.log('StackItem poppedblocId', block);
      const blockType = block?.flavour;
      return blockType || '';
    }
    return '';
  }

  /**
   * 跟踪 undo/redo 操作
   */
  private _trackUndoRedoOperation(
    docId: string,
    type: 'undo' | 'redo',
    data: any
  ): void {
    try {
      // 获取当前文档状态
      const canUndo = this.doc.blockSuiteDoc?.canUndo ?? false;
      const canRedo = this.doc.blockSuiteDoc?.canRedo ?? false;

      // 🔑 直接使用 track 进行跟踪
      if (type === 'undo') {
        track.doc.editor.userAction.canvas_edit_action({
          edit_type: 'undo',
          block_type: data.blockType,
          doc_id: docId,
        });
      } else if (type === 'redo') {
        track.doc.editor.userAction.canvas_edit_action({
          edit_type: 'redo',
          block_type: data.blockType,
          doc_id: docId,
        });
      }

      console.log(`�� 已发送文档 ${docId} ${type} track 数据:`, {
        edit_type: type,
        block_type: data.blockType,
        doc_id: docId,
        canUndo,
        canRedo,
        ...data,
      });
    } catch (error) {
      console.error('❌ 发送 undo/redo track 数据失败:', error);
    }
  }

  /**
   * 🔑 清理所有 undo/redo 监听器
   */
  public cleanupUndoRedoListeners(): void {
    for (const [docId, cleanup] of this._undoRedoListeners) {
      cleanup();
      console.log(`🧹 已清理文档 ${docId} 的 undo/redo 监听器`);
    }
    this._undoRedoListeners.clear();
  }

  /**
   * 🔑 销毁服务
   */
  destroy(): void {
    this.cleanupUndoRedoListeners();
  }
}
